<!--
  A Bulma-styled text input field with a label, validation, and two-way binding for the input value
-->
<template>
  <div class="fieldWrapper field">
    <div style="display:flex">
      <label v-if="label" class="label">{{ label }}</label>
      <slot name="top"/>
    </div>

    <p v-if="description" class="mb-2">{{description}}</p>

    <div class="control">
      <input
        ref="inputElem"
        class="input"
        :type="isPassword ? 'password' : 'text'"
        :value="modelValue"
        :maxlength="length"
        @input="onInput(false)"
        @blur="onInput(true)"
        @keyup.enter="emit('enter')"
        :disabled="isDisabled"
        :placeholder="placeholder"
        :autocomplete="noAutoFill ? 'new-password': ''"
        :class="{ 'is-danger': validator ? !validator(validationId ? validationId : this, modelValue) : false }"
      />
      <slot/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { trimString } from "@/core/utils";
import { onMounted, ref } from "vue";

const props = defineProps<{
  modelValue?: string|number,
  label?: string,
  description?: string,
  placeholder?: string,
  
  isPassword?: boolean,

  trimmed?: boolean,
  numeric?: boolean,
  length?: number,

  validator?: (fieldId: any, val: any) => boolean,
  validationId?: string,

  isDisabled?: boolean,
  autoFocus?: boolean,
  noAutoFill?: boolean,
}>();

// The input element where the form field's value will be bound
const inputElem = ref<any>(null);

// Event for two-way binding
const emit = defineEmits(['update:modelValue', 'enter'])

const onInput = (isBlur: boolean) => {
  let val: string = inputElem.value.value;
  if (isBlur && props.trimmed) { val = trimString(val); }
  if (props.numeric) { val = val.replaceAll(/[^0-9\\.]/g, ''); }
  inputElem.value.value = val;

  emit('update:modelValue', val);
};

onMounted(() => {
  if (props.autoFocus) {
    inputElem.value.focus();
  }

  if (props.trimmed && trimString(props.modelValue) != props.modelValue) {
    emit('update:modelValue', trimString(inputElem.value.value));
  }
})
</script>